/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, CircularProgress } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { useObjectContext } from '@/hooks/useObjectContext';

const SCOPE_OF_ADVICE_UNLAYER_TEMPLATE_NAME = 'scope of advice';
const WELCOME_EMAIL_UNLAYER_TEMPLATE_NAME = 'welcome email';

export const SendScopeOfAdviceButton = () => {
	const dispatch = useDispatch();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const userQuery = useGetUserDetailsQuery({ email }, { skip: !email });
	const { dealRow, clientRow } = useObjectContext();

	const countryCode = userQuery?.data?.broker?.country ?? 'NZ';
	const isAustralian = countryCode === 'AU';

	const { getFeatureFlags } = useFeatureFlagContext();

	const showUnlayerEmails = Boolean(getFeatureFlags('unlayerEmails')?.active);

	return (
		<>
			<Button
				disabled={!userQuery.data}
				variant='tab_header'
				startIcon={<EmailIcon />}
				onClick={() => {
					if (showUnlayerEmails) {
						dispatch(
							openDialog({
								dialogName: 'unlayerEmail',
								data: {
									clientLocked: true,
									dealLocked: true,
									client: clientRow ?? null,
									deal: dealRow ?? null,
									templateName: isAustralian
										? WELCOME_EMAIL_UNLAYER_TEMPLATE_NAME
										: SCOPE_OF_ADVICE_UNLAYER_TEMPLATE_NAME,
									injectScopeOfAdviceTable: true,
								},
							}),
						);
					} else {
						dispatch(
							openDialog({
								dialogName: 'email',
								data: { template: isAustralian ? 'welcomeEmail' : 'scopeOfAdvice' },
							}),
						);
					}
				}}
			>
				{isAustralian ? 'Send Welcome Email' : 'Email Scope of Advice'}
			</Button>
		</>
	);
};
